import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TDropdownItem } from '../../form/model/form.model';
import * as uuid from 'uuid';
import { TTableVirtualScrollConfig } from '../../table/models/table.type';

@Component({
  selector: 'monorepo-multi-select-dropdown',
  templateUrl: './multi-select-dropdown.component.html',
  styleUrls: ['./multi-select-dropdown.component.scss'],
})
export class MultiSelectDropdownComponent {
  @Input() virtualScroll?: TTableVirtualScrollConfig = undefined;
  _dropdownList: TDropdownItem[] = [];
  _dropdownConfig = {
    isMultiSelect: true,
    isClearOption: false,
    isDisabled: false,
    placeHolder: '',
  };
  @Input() set dropdownConfig(config: {
    isMultiSelect?: boolean;
    isClearOption?: boolean;
    isDisabled?: boolean;
    placeHolder?: string;
  }) {
    this._dropdownConfig = { ...this._dropdownConfig, ...config };
  }

  @Input() set dropdownData(dropdowns: {
    items: TDropdownItem[];
    defaultSelectedItems?: number | string | (number | string)[];
  }) {
    const defaultSelectedItems = dropdowns.defaultSelectedItems;
    this._dropdownList =
      defaultSelectedItems === undefined
        ? [...dropdowns.items]
        : dropdowns.items.map((item) => {
            return {
              ...item,
              isSelected: Array.isArray(defaultSelectedItems)
                ? defaultSelectedItems.includes(item.value)
                : defaultSelectedItems === item.value,
            };
          });
    this.selectedDropdownList = this._dropdownList.filter((item) => item.isSelected);
    this.filteredDropdownList = this.#getVisibleDropdownList();
  }

  @Output() selectedList = new EventEmitter<TDropdownItem['value'][]>();

  popverId = uuid.v4();
  isDropdownOpen = false;
  #searchText = '';
  filteredDropdownList: TDropdownItem[] = [];
  selectedDropdownList: TDropdownItem[] = [];
  dropdownChevron = 'assets/common/chevron-close-block.svg';

  openDropdown() {
    if (!this._dropdownConfig.isDisabled) {
      this.isDropdownOpen = true;
    }
  }

  onSearch($event: Event) {
    this.#searchText = (($event.target as HTMLInputElement).value ?? '').toLocaleLowerCase();
    this.filteredDropdownList = this.#getVisibleDropdownList();
  }

  onClearSearch() {
    this.#searchText = '';
    this.filteredDropdownList = this.#getVisibleDropdownList();
  }

  handlePopOverDismiss() {
    this.isDropdownOpen = false;
    this.#searchText = '';
    this.filteredDropdownList = this.#getVisibleDropdownList();
  }

  #matchesSearchText(item: TDropdownItem) {
    if (!this.#searchText) return true;
    return (
      (item.value.toString() + '%' + (item.displayName || '').toString())
        .toLocaleLowerCase()
        .indexOf(this.#searchText) >= 0
    );
  }

  #getVisibleDropdownList(selectedValues?: Set<TDropdownItem['value']>) {
    const selectedItemValues = selectedValues ?? new Set(this.selectedDropdownList.map((item) => item.value));
    return this._dropdownList
      .filter((item) => this.#matchesSearchText(item))
      .map((item) => ({ ...item, isSelected: selectedItemValues.has(item.value) }));
  }

  #updateSelection(selectedOrDeSelectedValue: TDropdownItem['value'], isChecked: boolean) {
    const selectedValues = new Set(this.selectedDropdownList.map((item) => item.value));

    if (!this._dropdownConfig.isMultiSelect) selectedValues.clear();

    if (isChecked) selectedValues.add(selectedOrDeSelectedValue);
    else selectedValues.delete(selectedOrDeSelectedValue);

    this.selectedDropdownList = this._dropdownList
      .filter((item) => selectedValues.has(item.value))
      .map((item) => ({ ...item, isSelected: true }));
    this.filteredDropdownList = this.#getVisibleDropdownList(selectedValues);

    this.selectedList.emit(this.selectedDropdownList.map((item) => item.value));
  }

  onSelectOrDeselect($event: Event, option: TDropdownItem) {
    $event.stopPropagation();
    if (this._dropdownConfig.isDisabled) return;
    this.isDropdownOpen = this._dropdownConfig.isMultiSelect;
    this.#updateSelection(option.value, !option.isSelected);
  }

  trackByOptionValue = (_index: number, option: TDropdownItem) => option.value;

  onDeSelectItemFromClearCrossIcon($event: Event, deSelectedValue: TDropdownItem['value']) {
    $event.stopPropagation();
    if (!this._dropdownConfig.isDisabled) this.#updateSelection(deSelectedValue, false);
  }
}
